// Native köprü yardımcı fonksiyonları
export const isAndroidApp = () => typeof window.AndroidBridge !== 'undefined';
export const isIOSApp = () => typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers !== 'undefined';
export const isNativeApp = () => isAndroidApp() || isIOSApp();

export function showRewardedAd() {
  if (isAndroidApp() && !window.__REMIL_IOS__) {
    window.AndroidBridge.showRewardedAd();
  } else if (isIOSApp()) {
    window.webkit.messageHandlers.showRewardedAd.postMessage({});
  }
}

export function showFalAd(onClosed) {
  if (isAndroidApp() && !window.__REMIL_IOS__) {
    window.onInterstitialClosed = () => { window.onInterstitialClosed = null; onClosed(); };
    window.AndroidBridge.showFalAd();
    setTimeout(() => {
      if (window.onInterstitialClosed) {
        window.onInterstitialClosed = null;
        onClosed();
      }
    }, 3000);
  } else {
    // iOS'ta fal gönderme reklamı yok, direkt devam et
    onClosed();
  }
}

export function showFalHemenOkuAd() {
  return new Promise((resolve, reject) => {
    window.onFalHemenOkuCompleted = () => { window.onFalHemenOkuCompleted = null; window.onFalHemenOkuFailed = null; resolve(); };
    window.onFalHemenOkuFailed = () => { window.onFalHemenOkuCompleted = null; window.onFalHemenOkuFailed = null; reject(); };
    if (isAndroidApp()) {
      window.AndroidBridge.showFalHemenOkuAd();
    } else if (isIOSApp()) {
      window.webkit.messageHandlers.showFalHemenOkuAd.postMessage({});
    } else {
      reject();
    }
    setTimeout(() => {
      if (window.onFalHemenOkuCompleted) {
        window.onFalHemenOkuCompleted = null;
        window.onFalHemenOkuFailed = null;
        reject();
      }
    }, 120000);
  });
}
